import { createSelector } from "reselect";

import { KEY_REDUCER_SYSTEM } from "./constants";

export const selectorSystemLoaders = (state) => state[KEY_REDUCER_SYSTEM].loaders;
export const selectorSystemMessages = (state) => state[KEY_REDUCER_SYSTEM].messages;
export const selectorSystemOnLine = (state) => state[KEY_REDUCER_SYSTEM].onLine;
export const selectorSystemIsLogin = (state) => state[KEY_REDUCER_SYSTEM].isLogin;
export const selectorUserInfo = (state) => state[KEY_REDUCER_SYSTEM].userInfo;
export const selectorAvatarLastUpdateTimestamp = (state) => state[KEY_REDUCER_SYSTEM].avatarLastUpdateTimestamp;
export const selectorSystemDataAcquisitionStatus = (state) =>
  state[KEY_REDUCER_SYSTEM].dataAcquisitionStatus;
export const selectorSystemIsTopPanelVisible = (state) => {
  return state[KEY_REDUCER_SYSTEM].isTopPanelVisible;
};

export const selectorLoaderById = createSelector(
  selectorSystemLoaders,
  (_, loadingId) => loadingId,
  (loaders, loadingId) => loaders.some((id) => id === loadingId),
);
